<dv-grid [actions]="actions">
  <ag-grid-angular
    vtGridWithSidesheet
    dvPinSelectedRow
    class="ag-theme-devinco"
    [gridOptions]="gridOptions">
  </ag-grid-angular>
</dv-grid>
